module.exports = __webpack_public_path__ + "VAGRoundedStd-Black.70c16a9389834c3b4645.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Black.woff
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Black.woff
// module chunks = styles